module.exports = __webpack_public_path__ + "img/goal-10.f901202c.png";